module.exports = __webpack_public_path__ + "static/media/greg-neutro.19578f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/greg-neutro.png
// module id = 3527
// module chunks = 0